import ActionTypes from '../constants/actionTypes';
import { pricingRequestDefaults } from './defaultStates';
import EMAIL_CODES from '../constants/emailCodes';

export default function(state = pricingRequestDefaults, action) {
  switch (action.type) {
    case ActionTypes.UPDATE[EMAIL_CODES.PRICING_REQUEST]:
      return {
        sendingSucceeded: true,
        isFetching: false
      };
    case ActionTypes.REQUEST[EMAIL_CODES.PRICING_REQUEST]:
      return { ...state, sendingSucceeded: false, isFetching: true };
    case ActionTypes.FAILED2FETCH[EMAIL_CODES.PRICING_REQUEST]:
      return { ...state, sendingSucceeded: false, isFetching: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_pricingRequest.js